import { Modal } from '@mui/material'
import classNames from 'classnames'
import { useDispatch } from 'react-redux'
import ButtonCloseModal from '../Buttons/ButtonCloseModal'
import InfoIconBlock from '../Info/InfoIconBlock'

const InfoModal = ({
  open = false,
  // handleClose = () => {},
  closeSetter = () => {},
  title = '',
  subtitle = '',
  info_msg = '',
  className = '',
}) => {
  const dispatch = useDispatch()
  const handleClose = () => {
    dispatch(closeSetter(false))
  }

  return (
    <Modal
      className={classNames(className, 'info_modal modal_wrapper')}
      open={open}
      onClose={handleClose}
    >
      <div className="modal_component">
        <div className="modal_main">
          <ButtonCloseModal handler={handleClose} />
          {title && <span className="modal_title">{title}</span>}
          {subtitle && <span className="modal_subtitle">{subtitle}</span>}
        </div>
        {info_msg && (
          <InfoIconBlock info_msg="QR-квиток є дійсним протягом 15 днів з моменту його придбання." />
        )}
      </div>
    </Modal>
  )
}

export default InfoModal
